import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import FixedRates from "./components/carrier/fixed-rates/FixedRates";

import FixedRatesForm from "./components/carrier/fixed-rates/FixedRatesForm.vue";
import LocationsPage from "./components/sender/locations/LocationsPage";
import DashboardPage from "./components/dashboard/DashboardPage";
import BookingsPage from "./components/bookings/BookingsPage";
import CurrentBookingsTab from "./components/bookings/components/tabs/CurrentBookingsTab";
import CompletedBookingsTab from "./components/bookings/components/tabs/CompletedBookingsTab";
import CancelledBookingsTab from "./components/bookings/components/tabs/CancelledBookingsTab";
import DifotReportBookingsTab from "./components/bookings/components/tabs/DifotReportBookingsTab";
import ManifestBookingsTab from "./components/bookings/components/tabs/ManifestBookingsTab";
import ExportBookingsTab from "./components/bookings/components/tabs/ExportBookingsTab";
import CarrierPage from "./components/carrier/CarrierPage";
import FreightOffersTab from "./components/carrier/components/tabs/FreightOffersTab";
import CarrierDifot from "./parents/carrier/CarrierDifot";
import RunSheets from "./parents/carrier/RunSheets";
import CarrierConsignmentsTab from "./components/carrier/components/tabs/CarrierConsignmentsTab";
import CarrierDashboard from "./parents/carrier/dashboard/CarrierDashboard";

import DepotPage from "./components/depot/DepotPage";

const routes = [
  // Route for carrier fixed-rates
  {
    path: "/carry-freight/fixed-rates",
    component: FixedRates,
    children: [
      { path: "new", component: FixedRatesForm, name: "newFixedRatesForm" },
      {
        path: ":id(\\d+)",
        component: FixedRatesForm,
        name: "editFixedRatesForm"
      }
    ]
  },
  { path: "/settings/locations", component: LocationsPage },
  { path: "/send-freight/dashboard", component: DashboardPage },
  {
    path: "/send-freight/bookings",
    name: "bookings",
    component: BookingsPage,
    props: true,
    children: [
      {
        path: "current",
        name: "currentBookings",
        component: CurrentBookingsTab,
        props: true
      },
      {
        path: "completed",
        name: "completedBookings",
        component: CompletedBookingsTab
      },
      {
        path: "cancelled",
        name: "cancelledBookings",
        component: CancelledBookingsTab
      },
      {
        path: "difot",
        name: "difotReportBookings",
        component: DifotReportBookingsTab
      },
      {
        path: "manifest",
        name: "manifestBookings",
        component: ManifestBookingsTab
      },
      { path: "export", name: "exportBookings", component: ExportBookingsTab }
    ]
  },
  { path: "/carry-freight/dashboard", component: CarrierDashboard },
  {
    path: "/carry-freight",
    component: CarrierPage,
    props: true,
    children: [
      {
        path: "offers",
        name: "carrierFreightOffers",
        component: FreightOffersTab
      },
      {
        path: "consignments",
        name: "carrierConsignments",
        component: CarrierConsignmentsTab,
        props: true
      },
      {
        path: "difot",
        name: "carrierDifot",
        component: CarrierDifot
      },
      {
        path: "run-sheets",
        name: "runSheets",
        component: RunSheets
      }
    ]
  },
  {
    path: "/depot",
    component: DepotPage
  }
];

export default new VueRouter({
  routes: routes,
  mode: "history"
});
